import React from 'react'
import FooterTop from './menu/menu-footer-top'
import FooterBottom from './menu/menu-footer-bottom'

const Footer = ({ hides }) => {
  const styleOverrides = {};

  const showFooterTop = !hides || !hides.footer_top;
  const showFooterBottom = !hides || !hides.footer_bottom;

  if (!showFooterTop || !showFooterBottom) {
    styleOverrides.style = {
      paddingTop: 0
    }
  }

  return (
    <footer className="footer" {...styleOverrides}>
      {showFooterTop && <div className="footer-top">
        <FooterTop />
      </div>}
      {showFooterBottom && <div className="footer-bottom">
        <div className="container">
          <FooterBottom />
        </div>
      </div>}
    </footer>
  )
}

export default Footer
